import ParameterContext from 'effects/ParameterContext.js';
import {setEffectParameterValue, setScriptVariables} from 'actions/index.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

export default superclass => class extends superclass  {
    parameterVariables = [];
    checkboxVariables = [];
    trackVariables = [];
    variables = [];
    
    // returns value (lazily) of given parameter
    var(name) {
        if (this.scriptEffect) {
            return this.scriptEffect.var(name);
        }
        return () => {
            let variable = this[name + 'Parameter'];
            if (variable) {
                return variable.get();
            }
            return 0;
        };
    }

    newParamVar(name) {
        let variable = new AbstractParameter(
            name, this, (o, x) => x,
           {
               min: 0,
               max: 16,
               unit: '',
               defaultValue: ''
            });

        this[name + 'Parameter'] = variable;
        this.registerParameter(variable);
        this.parameterVariables.push(variable);
    }

    newTrackVar(name) {
        let variable = new AbstractParameter(
            name, this, (o, x) => x,
           {
               min: 0,
               max: 16,
               unit: '',
               defaultValue: 0
            });
        this[name + 'Parameter'] = variable;
        this.registerParameter(variable);
        this.trackVariables.push(variable);
    }

    newCheckboxVar(name, defaultValue) {
        let variable = new AbstractParameter(
            name, this, (o, x) => x,
           {
               min: 0,
               max: 1,
               unit: '',
               defaultValue: defaultValue
            });
        this[name + 'Parameter'] = variable;
        this.registerParameter(variable);
        this.checkboxVariables.push(variable);
    }

    newVar(name, value, min, max, documentation, hide, onChange) {
        if (this.scriptEffect) {
            return this.scriptEffect.newVar(name, value, min, max, documentation, hide);
        }
        if (this[name + 'Parameter']) {
            // first check if it's part of parameters
            this.variables = this.variables.filter(
                v => v.name !== name);
            this.variables.push(this[name + 'Parameter']);
            return this[name + 'Parameter'];
        } 

        if (this.oldVariables) {
            let oldVariable = this.oldVariables.find(x => x.name === name);
            if (oldVariable) {
                this.variables = this.variables.filter(
                v => v.name !== name);
                this.variables.push(oldVariable);
                this[name + 'Parameter'] = oldVariable;
                this.registerParameter(oldVariable);
                return oldVariable;
            } 
        } 

        let variable = new AbstractParameter(
            name, this, (o, x) => x,
            {
                min,
                max,
                unit: '',
                defaultValue: value,
                documentation,
                hide,
                onChange
            });
        
        this[name + 'Parameter'] = variable;
        this.registerParameter(variable);
        if (this.context === undefined) {
            this.context = new ParameterContext()
                .forMidiEffect(this)
                .forTrack(this.track);
        }
        variable.setContext(this.context);
        this.variables.push(variable);

        this.track.sequencerEngine.dispatch(
            setEffectParameterValue(
                variable.i, value));

        return variable;
    }

    updateVariablesRedux() {
        let x = (this.track && this.track.sequencerEngine) || this.sequencerEngine;
        if (x) {
            x.dispatch(
                setScriptVariables(
                    this.id, [... this.variables]));
        }
    }

    clearVariables() {
        let values = {};
        if (this.scriptEffect) {
            return values;
        }

        for (let v of this.variables) {
            values[v.name] = v;
            delete this[v.name + 'Parameter'];
            this.parameters = this.parameters.filter(
                p => p.name !== v.name);
        }


        this.oldVariables = [ ... (this.oldVariables || []), ...this.variables];
        this.variables = [];
        return values;
    };
}
